import { ThemeOption } from '@helpers/brand';
import { useBaseProps } from '@hoc/withBaseProps';
import * as React from 'react';
import S from './SectionWrapper.styles';
const SectionWrapper = React.forwardRef((props, ref) => {
    const { children, layout = 'default', theme = ThemeOption.Default, includeBottomOverlap = false, ...otherProps } = props;
    const baseProps = useBaseProps();
    return (React.createElement(S.Container, { ref: ref, id: baseProps.id, "data-s-top": baseProps.separatorTop ?? 'default', "data-s-bottom": baseProps.separatorBottom ?? 'default', "data-theme": theme, "data-overlap-bottom": includeBottomOverlap, "data-allow-top-separator": baseProps.separatorTop == 'slantLeft' || baseProps.separatorTop == 'slantRight', "data-allow-scroll-margin": !!baseProps.id, ...otherProps },
        React.createElement(S.Separator, { "data-top": true, "aria-hidden": true }),
        React.createElement(S.SeparatorLogo, { "data-top": true }),
        React.createElement(S.Inner, null, renderLayout()),
        React.createElement(S.Separator, { "aria-hidden": true, "data-bottom": true }),
        React.createElement(S.SeparatorLogo, { "data-bottom": true })));
    function renderLayout() {
        if (layout === 'fullWidth') {
            return children;
        }
        return React.createElement(S.SiteWide, null, children);
    }
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
